import { memo } from 'react'
import { getTextareaClasses, labelClasses } from '../../styles/inputStyles'

/**
 * ContactAdminActions - Admin controls for contact submissions
 * Includes notes field and status update buttons
 */
const ContactAdminActions = memo(function ContactAdminActions({
  notes,
  onNotesChange,
  currentStatus,
  onStatusUpdate,
  loading = false
}) {
  return (
    <div className="bg-white rounded-lg shadow-md p-6 mb-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Admin Actions</h3>
      
      <div className="mb-4">
        <label className={labelClasses}>
          Admin Notes
        </label>
        <textarea
          value={notes}
          onChange={(e) => onNotesChange(e.target.value)}
          rows={4}
          className={getTextareaClasses()}
          placeholder="Add internal notes about this submission..."
        />
      </div>

      <div className="flex gap-2">
        <button
          onClick={() => onStatusUpdate('reviewed')}
          disabled={currentStatus === 'reviewed' || loading}
          className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Mark as Reviewed
        </button>
        <button
          onClick={() => onStatusUpdate('resolved')}
          disabled={currentStatus === 'resolved' || loading}
          className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Mark as Resolved
        </button>
        <button
          onClick={() => onStatusUpdate('spam')}
          disabled={currentStatus === 'spam' || loading}
          className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Mark as Spam
        </button>
      </div>
    </div>
  )
})

export default ContactAdminActions
